<template>
  <div class="coralvoice">
    <header>
      <router-link to="/coral" class="back">
        <i class="icon-left"></i>
      </router-link>
      <div class="title" v-html="coral.name"></div>
      <div v-if="coral.name === $store.state.player.voiceName" class="nowToPlayer">
        <i :class="[ $store.state.player.playnow ? 'icon-pa' :'icon-player']" @click="pause()"></i>
      </div>
      <div v-if="coral.name !== $store.state.player.voiceName" class="nowToPlayer">
        <i class="icon-player" @click="playVoice(hash)"></i>
        <div class="prompt animated fadeInUp infinite"><i class="icon-s5-582"></i>播放</div>
      </div>
    </header>
    <div class="headerBlk"></div>
    <div class="container">
      <div class="item">
        <div class="swiperbox">
          <swiper :options="swiperOption">
            <swiper-slide v-for="im in coral.img" :key="im.id"><img :src="'./static/img/'+im" class="itimg swiper swiper-lazy"></swiper-slide>
            <div class="swiper-pagination" slot="pagination"></div>
            <div class="swiper-button-prev icon-circle-left2" slot="button-prev"></div>
            <div class="swiper-button-next icon-circle-right2" slot="button-next"></div>
          </swiper>
        </div>
        <div class="cont" v-html="coral.cont"></div>
      </div>
    </div>
    <div class="navsBlk"></div>
  </div>
</template>

<script>
import navs from '@/components/nav'
export default {
  name: 'coralvoice',
  components: {
    navs
  },
  data() {
    return {
      brand: '',
      coral: '',
      item: '',
      msg: 'voice',
      hash: '',
      articles: [],
      category: '',
      id: '',
      nameTitle: '',
      img: './static/img/' + this.hash + '.jpg',
      cont: '',
      conts: '',
      swiperOption: {
        spaceBetween: 30,
        centeredSlides: true,
        autoplay: {
          delay: 5000,
          disableOnInteraction: false
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      }
    }
  },
  created() {
    // document.body.scrollTop = 0
    $(window).scrollTop(0)
    // this.$store.state.player.playerDisplay = true
    this.fetchArticles()
    let hash = window.location.hash

    if (hash.indexOf('brand') > 0) {
      this.category = 'brand'
    }
    if (hash.indexOf('coral') > 0) {
      this.category = 'coral'
    }
    if (hash.indexOf('item') > 0) {
      this.category = 'item'
    }

    var int = _.replace(hash, '#/' + this.category + '/', '')
    this.hash = parseInt(int)
  },
  methods: {
    playVoice(it) {
      this.$store.state.player.idNb = it
      this.$store.state.player.toUrl = '/coral/' + it
      this.$store.state.player.imgUrl =
        './static/img/' + this.category + '-' + it + '-0.jpg'
      this.$store.state.player.voiceName = this.coral.name
      this.$store.dispatch('SET_PLAY_URL', './static/mp3/coral-' + it + '.mp3')
      this.$store.dispatch(
        'SET_PLAY_URL_IOS',
        './static/mp3/coral-' + it + '.mp3'
      )
      // this.$store.state.player.ize = true
      this.$store.state.player.prompts = false
    },
    pause() {
      this.$store.dispatch('SET_PAUSE')
    },
    fetchArticles: function() {
      axios
        .get('@/../static/item.json', {
          id: this.hash
        })
        .then(res => {
          this.brand = res.data.brand[this.hash - 1]
          this.coral = res.data.coral[this.hash - 1]
          this.item = res.data.item[this.hash - 1]
        })
        .catch(err => {
          console.log(err)
        })
    }
  },
  mounted() {}
}
</script>

<style lang="scss" scoped>
@import '../assets/scss/color.scss';
@import '../assets/scss/ly.scss';

h1,
h2 {
  font-weight: normal;
  a {
    color: rgb(153, 69, 108);
  }
}
.swiperbox {
  // width: 90%;
  // padding: 0;
  display: block;
  height: auto;
  margin: 12px auto;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 3px 12px 1px rgba(188, 199, 207, 0.8);
  .icon-circle-left2,
  .icon-circle-right2 {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1rem;
  }
}
.swiper-container.swiper-container-horizontal.swiper-container-ios {
  border-radius: 12px;
  overflow: hidden;
}
.swiper-container.swiper-container-horizontal.swiper-container-android {
  border-radius: 12px;
  overflow: hidden;
}
img.swiper {
  width: 100%;
  display: inline-block;
  float: left;
}
.item {
  width: 100%;
  .itimg {
    width: 100%;
  }
  .nowToPlayer {
    display: flex;
    justify-content: center;
    align-items: center;
    i {
      margin: 20px;
      cursor: pointer;
      &::before {
        font-size: 2rem;
      }
      &::after {
        content: '語音播放';
      }
    }
  }
  .cont {
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/coralvoice.vue